import http from "../http-common";

class DescountService {
  getAll() {
    return http.get("/descounts");
  }

  get(id) {
    return http.get(`/descounts/${id}`);
  }

  create(data) {
    return http.post("/descounts", data);
  }

  update(id, data) {
    return http.put(`/descounts/${id}`, data);
  }

  delete(id) {
    return http.delete(`/descounts/${id}`);
  }

  getTrashed() {
    return http.get("/descounts/trashed/list");
  }

  restore(id) {
    return http.post(`/descounts/${id}/restore`);
  }
}

export default new DescountService();
